module.exports = __webpack_public_path__ + "img/mail.a27d34f1.svg";